var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlossary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_548",
    "data-name": "Group 548",
    transform: "translate(-898 -740)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 64,
    height: 64,
    transform: "translate(898 740)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_523",
    "data-name": "Group 523",
    transform: "translate(-1555.252 -123.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3707",
    "data-name": "Path 3707",
    d: "M2466.528,921.2l-1.331-.769a1.958,1.958,0,0,1-.747-1.639l.032-25.589a5.523,5.523,0,0,1,2.532-4.392l35.28-20.348a1.823,1.823,0,0,1,1.785-.171l1.33.769a1.825,1.825,0,0,0-1.785.172l-35.28,20.346a5.591,5.591,0,0,0-2.531,4.392l-.033,25.589a1.954,1.954,0,0,0,.748,1.64Z",
    transform: "translate(0.069 0.073)",
    fill: "#7bbdfd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3708",
    "data-name": "Path 3708",
    d: "M2503.436,868.58a2.183,2.183,0,0,0-.908.306l-35.249,20.33a5.2,5.2,0,0,0-2.368,4.092v25.557c.064.714.1.914.615,1.343l.033.017a2.766,2.766,0,0,1-.064-.556V894.045a5.97,5.97,0,0,1,2.692-4.706l35.315-20.362c.193-.09.356-.172.518-.234l-.064-.046a1.592,1.592,0,0,0-.519-.116ZM2466.6,921.653a.228.228,0,0,1-.162-.053l-1.363-.769a2.187,2.187,0,0,1-.909-1.934V893.276a5.969,5.969,0,0,1,2.694-4.706l35.313-20.364a2.211,2.211,0,0,1,2.108-.2l1.4.8a.372.372,0,0,1,.13.493.352.352,0,0,1-.455.194c-.649-.237-.81-.152-1.525.162l-35.216,20.33a5.091,5.091,0,0,0-2.336,4.089l-.033,25.56c.066.717.1.919.618,1.344a.383.383,0,0,1,.064.509.376.376,0,0,1-.327.166Z",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3709",
    "data-name": "Path 3709",
    d: "M2467.977,890.918l34.893-20.135c.616-.364,1.135-.069,1.135.659V895.15a2.55,2.55,0,0,1-1.135,1.971l-34.923,20.132c-.618.363-1.137.069-1.137-.659V892.888a2.5,2.5,0,0,1,1.167-1.97Z",
    transform: "translate(0.632 0.67)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3710",
    "data-name": "Path 3710",
    d: "M2468.208,891.323a2.2,2.2,0,0,0-.942,1.639v23.706c0,.206.033.357.13.409a.461.461,0,0,0,.422-.078l34.922-20.136a2.109,2.109,0,0,0,.943-1.639V871.515c0-.206-.033-.358-.13-.41a.454.454,0,0,0-.422.082l-34.923,20.136Zm-.714,26.54a1.034,1.034,0,0,1-.487-.128,1.17,1.17,0,0,1-.488-1.068V892.962a2.9,2.9,0,0,1,1.331-2.3h0l34.89-20.137a1.212,1.212,0,0,1,1.2-.078,1.193,1.193,0,0,1,.52,1.069v23.708a2.941,2.941,0,0,1-1.364,2.3l-34.891,20.132a1.412,1.412,0,0,1-.712.207Z",
    transform: "translate(0.563 0.597)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3711",
    "data-name": "Path 3711",
    d: "M2468.284,891.367a2.5,2.5,0,0,0-1.168,1.971v23.706c0,.729.519,1.022,1.137.659l34.923-20.132a2.55,2.55,0,0,0,1.135-1.971V871.892c0-.728-.519-1.023-1.135-.659l-34.893,20.135Zm-.194-1.934,35.28-20.346c1.4-.8,2.531-.144,2.531,1.466l-.031,25.589a5.621,5.621,0,0,1-2.532,4.393l-35.248,20.344c-1.4.8-2.564.146-2.564-1.464l.033-25.589a5.615,5.615,0,0,1,2.531-4.392Z",
    transform: "translate(0.325 0.22)",
    fill: "#c8e6fe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3712",
    "data-name": "Path 3712",
    d: "M2468.515,891.773a2.2,2.2,0,0,0-.942,1.639v23.706c0,.206.033.357.13.409a.461.461,0,0,0,.422-.078l34.922-20.136a2.109,2.109,0,0,0,.943-1.639V871.966c0-.206-.033-.358-.13-.41a.461.461,0,0,0-.422.082l-34.923,20.136Zm-.714,26.54a1.034,1.034,0,0,1-.487-.128,1.169,1.169,0,0,1-.487-1.068V893.412a2.9,2.9,0,0,1,1.331-2.3h0l34.89-20.137a1.073,1.073,0,0,1,1.722.991v23.708a2.941,2.941,0,0,1-1.364,2.3l-34.891,20.132a1.413,1.413,0,0,1-.714.206Zm.551-28.475L2503.6,869.49a1.456,1.456,0,0,1,1.428-.171,1.424,1.424,0,0,1,.551,1.307v25.589a5.224,5.224,0,0,1-2.368,4.061l-35.248,20.344a1.459,1.459,0,0,1-1.428.176,1.426,1.426,0,0,1-.552-1.308l.033-25.589A5.187,5.187,0,0,1,2468.352,889.838Zm-1.33,31.84a1.577,1.577,0,0,1-.844-.224,2.1,2.1,0,0,1-.94-1.966V893.9a6.061,6.061,0,0,1,2.725-4.722l35.281-20.346a2.079,2.079,0,0,1,2.141-.172,2.111,2.111,0,0,1,.941,1.969v25.589a5.979,5.979,0,0,1-2.727,4.724l-35.279,20.343a2.673,2.673,0,0,1-1.3.393Z",
    transform: "translate(0.257 0.146)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3713",
    "data-name": "Path 3713",
    d: "M2482.138,901.077a.156.156,0,0,0-.162.019.844.844,0,0,0-.194.175.648.648,0,0,0-.066.238.192.192,0,0,0,.066.152.205.205,0,0,0,.194-.016.651.651,0,0,0,.162-.18.607.607,0,0,0,.066-.233.187.187,0,0,0-.066-.155Z",
    transform: "translate(4.192 7.938)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3714",
    "data-name": "Path 3714",
    d: "M2482.019,901.484Zm0,0a.3.3,0,0,0,.13.036c0-.038-.032-.082-.1-.11a.186.186,0,0,0-.162-.028c.034,0,.064.064.13.1Zm-.1.653a.518.518,0,0,1-.52-.551,1.047,1.047,0,0,1,.129-.431,1,1,0,0,1,.324-.315.554.554,0,0,1,.552-.015.546.546,0,0,1,.26.484,1.041,1.041,0,0,1-.131.426.929.929,0,0,1-.291.313.8.8,0,0,1-.321.085Z",
    transform: "translate(4.117 7.864)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3715",
    "data-name": "Path 3715",
    d: "M2471.5,891.95l25.836-14.917v17.809L2471.5,909.755Z",
    transform: "translate(1.752 2.199)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3716",
    "data-name": "Path 3716",
    d: "M2471.963,892.244V909.17l25.056-14.475V877.769l-25.056,14.474Zm-.389,17.968a.407.407,0,0,1-.2-.051.364.364,0,0,1-.2-.332V892.023a.361.361,0,0,1,.2-.331l25.835-14.918a.4.4,0,0,1,.389,0,.441.441,0,0,1,.2.332v17.809a.418.418,0,0,1-.2.326l-25.835,14.919a.4.4,0,0,1-.194.051Z",
    transform: "translate(1.677 2.126)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3717",
    "data-name": "Path 3717",
    d: "M2471.5,892.445l25.836-14.917V874.96L2471.5,889.877Z",
    transform: "translate(1.752 1.704)",
    fill: "#c8e6fe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3718",
    "data-name": "Path 3718",
    d: "M2471.963,890.172v1.684l25.056-14.476v-1.687Zm-.389,2.727a.4.4,0,0,1-.2-.052.359.359,0,0,1-.2-.328V889.95a.362.362,0,0,1,.2-.331l25.835-14.915a.388.388,0,0,1,.389,0,.43.43,0,0,1,.2.33V877.6a.438.438,0,0,1-.2.331l-25.835,14.914a.391.391,0,0,1-.194.055Z",
    transform: "translate(1.677 1.631)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3719",
    "data-name": "Path 3719",
    d: "M2476.86,889.716h0c.2-.115.358-.024.358.2h0a.791.791,0,0,1-.358.617h0c-.194.114-.357.02-.357-.2h0A.785.785,0,0,1,2476.86,889.716Z",
    transform: "translate(2.947 5.216)",
    fill: "#c8e6fe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3720",
    "data-name": "Path 3720",
    d: "M2476.935,889.789Zm-.162,1.252a.663.663,0,0,1-.292-.078.6.6,0,0,1-.292-.559,1.148,1.148,0,0,1,.553-.948.593.593,0,0,1,.617-.024.63.63,0,0,1,.324.559,1.236,1.236,0,0,1-.551.948.857.857,0,0,1-.36.1Z",
    transform: "translate(2.872 5.143)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3721",
    "data-name": "Path 3721",
    d: "M2476.86,892.888h0c.2-.116.358-.023.358.2h0a.8.8,0,0,1-.358.617h0c-.194.113-.357.02-.357-.208h0a.789.789,0,0,1,.357-.609Z",
    transform: "translate(2.947 5.974)",
    fill: "#c8e6fe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3722",
    "data-name": "Path 3722",
    d: "M2476.935,892.961Zm-.162,1.254a.645.645,0,0,1-.292-.079.6.6,0,0,1-.292-.561,1.151,1.151,0,0,1,.553-.944h0a.586.586,0,0,1,.617-.026.63.63,0,0,1,.324.561,1.243,1.243,0,0,1-.551.948.854.854,0,0,1-.36.1Z",
    transform: "translate(2.872 5.9)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3723",
    "data-name": "Path 3723",
    d: "M2476.86,896.256h0c.2-.114.358-.023.358.206h0a.788.788,0,0,1-.358.616h0c-.194.114-.357.02-.357-.208h0a.8.8,0,0,1,.357-.614Z",
    transform: "translate(2.947 6.779)",
    fill: "#c8e6fe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3724",
    "data-name": "Path 3724",
    d: "M2476.935,896.33Zm-.162,1.254a.616.616,0,0,1-.292-.078.6.6,0,0,1-.292-.562,1.149,1.149,0,0,1,.553-.944.589.589,0,0,1,.617-.026.638.638,0,0,1,.324.563,1.241,1.241,0,0,1-.551.946.855.855,0,0,1-.36.1Z",
    transform: "translate(2.872 6.705)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3725",
    "data-name": "Path 3725",
    d: "M2478.829,893.65a.383.383,0,0,1-.2-.713l10.094-5.83a.373.373,0,0,1,.52.136.353.353,0,0,1-.131.523l-10.094,5.832A.392.392,0,0,1,2478.829,893.65Z",
    transform: "translate(3.412 4.592)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3726",
    "data-name": "Path 3726",
    d: "M2478.829,890.477a.384.384,0,0,1-.195-.711l10.094-5.832a.373.373,0,0,1,.52.14.349.349,0,0,1-.131.519l-10.094,5.832A.392.392,0,0,1,2478.829,890.477Z",
    transform: "translate(3.412 3.835)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3727",
    "data-name": "Path 3727",
    d: "M2478.829,896.8a.384.384,0,0,1-.195-.711l8.178-4.715a.375.375,0,1,1,.357.658l-8.146,4.716A.393.393,0,0,1,2478.829,896.8Z",
    transform: "translate(3.412 5.612)",
    fill: "#2874e7",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlossary);
export default __webpack_public_path__ + "static/media/glossary.ffce9271acaa569f3444d2fc1f01192c.svg";
export { ForwardRef as ReactComponent };